import { Link } from "react-router-dom";

import React, {Component} from 'react';
const {containsPermission} = require("../helper");

class Menu extends Component{

    constructor(props){
        super(props);
        let path = window.location.pathname.split("/")[1]
        path = path.length === 0 ? "dashboard" : path
        this.state = {
            selected_item : path,
            menu:{
                dashboard : {
                    name: 'დავალებები',
                    to: '/dashboard',
                    permission: null
                },
                profile : {
                    name: 'პროფილი',
                    to: '/profile',
                    permission: null
                },
                users : {
                    name: 'მომხმარებლები',
                    to: '/users',
                    permission: 'users.see'
                },
                roles : {
                    name: 'როლები',
                    to: '/roles',
                    permission: "roles.see"
                },
                types : {
                    name: 'ტიპები',
                    to: '/types',
                    permission: "types.see"
                },
                stages : {
                    name: 'მდგომარეობები',
                    to: '/stages',
                    permission: "stages.see"
                },
                problems : {
                    name: 'პრობლემები',
                    to: '/problems',
                    permission: "problems.see"
                },
                dashboard_settings:{
                    name:'დავალების პარამეტრები',
                    to: '/dashboard_settings',
                    permission:"dashboard_settings.see"
                }
            }
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot){
        
        if(prevProps.user !== this.props.user){
            this.setState({
               menu:{
                   ...this.state.menu,
                   profile:{
                        name: 'პროფილი',
                        to: '/profile/'+this.props.user.id,
                        permission: null
                   }
               }
            })
        }
        
        if(prevProps.location !== this.props.location){
            let path = this.props.location.split("/")[1]
            path = path.length === 0 ? "dashboard" : path
            this.setState({
                selected_item:path
            })
        }
    }

    
    make_menu_items(){
        let menu_items = [];
        Object.keys(this.state.menu).forEach(menuKey => {
            const menu = this.state.menu[menuKey]
            if(menu.permission === null || containsPermission(this.props.permissions, menu.permission)){
                menu_items.push(<Link  
                    key = {menuKey} 
                    to = {menu.to} 
                    onClick = {( ) => this.setState({selected_item : menuKey})} 
                    className={`${this.state.selected_item === menuKey && 'active_menu_item'}`} >
                        {menu.name} 
                    </Link>)
            }
        })
        
        return menu_items
    }
    render(){
        let menu_items = this.make_menu_items();
        return(
            <div className = "menu" id = "menu">
                {menu_items}
            </div>    
        )
    }
}


export default Menu